/**
 * MSAL v5 popup-fallback: Hvis Entra sender til approt i stedet for redirect.html,
 * omdiriger popup til redirect.html med samme hash slik at redirect-bridge kan kjøre.
 */
if (typeof window !== 'undefined' && window.opener && window.location.pathname === '/' && window.location.hash) {
  const hash = window.location.hash;
  if (hash.includes('code=') || hash.includes('state=')) {
    window.location.replace(`${window.location.origin}/redirect.html${hash}`);
  }
}

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import specific icons */
import
{
  faAngleDown,
  faArrowDown,
  faArrowDownAZ,
  faBallotCheck,
  faArrowDownZA,
  faArrowDownWideShort,
  faArrowUpShortWide,
  faArrowLeft,
  faArrowLeftLongToLine,
  faArrowRight,
  faArrowTurnDownRight as falArrowTurnDownRight,
  faArrowUp,
  faBell,
  faBookmark,
  faBug,
  faBugSlash,
  faBuilding,
  faChartDiagram,
  faChartLine,
  faChartLineUp,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronsLeft as falChevronsLeft,
  faChevronsRight as falChevronsRight,
  faCircleCheck as falCircleCheck,
  faClockRotateLeft,
  faCode,
  faCodeCompare,
  faCog,
  faCogs,
  faColumns3,
  faColumns as falColumns,
  faArrowRightArrowLeft as falArrowRightArrowLeft,
  faWandMagicSparkles as falWandMagicSparkles,
  faRocket as falRocket,
  faCopy,
  faDiagramProject,
  faDownToBracket,
  faEquals,
  faEye,
  faEyeSlash,
  faFile,
  faFileArchive,
  faFileCircleExclamation,
  faFileCode,
  faFileCsv,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileLines,
  faFileMagnifyingGlass,
  faFilePdf,
  faFileText,
  faFileXls,
  faFileZipper,
  faFilter,
  faFilterSlash,
  faFloppyDisk,
  faGreaterThan,
  faGreaterThanEqual,
  faGripLines,
  faHouse,
  faInfinity,
  faInfoCircle as falInfoCircle,
  faLayerPlus,
  faLessThan,
  faLessThanEqual,
  faListDropdown,
  faLock,
  faMagnifyingGlassChart,
  faMemoCircleCheck,
  faMemoCircleInfo,
  faMinus,
  faMinusCircle,
  faNotEqual,
  faOctagonExclamation,
  faPaperPlane,
  faPencil,
  faPenField,
  faPlay,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faQuestion,
  faQuestionCircle,
  faRectangleList,
  faRectangleApi,
  faRotate,
  faRotateLeft,
  faRotateRight as falRotateRight,
  faSearch,
  faSearchMinus,
  faDiamondExclamation,
  faSliders,
  faSpinner,
  faSquare,
  faTable,
  faTableList,
  faTimes,
  faTrash,
  faTrashCan,
  faTrashUndo,
  faTriangleExclamation,
  faToolbox,
  faTags,
  faUpDownLeftRight,
  faUser,
  faUsers,
  faUsersGear,
  faFolderOpen as falFolderOpen, faListCheck, faList, faBox,
  faFolderCheck, faCabinetFiling, faFolderMagnifyingGlass, faUpFromBracket, faFileArrowUp,
  faUpRightFromSquare, faShieldHalved, faGlobe, faSquarePollHorizontal, faKeySkeleton, faRightLeftLarge, faHourglassHalf,
  faBan, faDatabase, faDownload, faExclamationTriangle, faSave, faStar, faFileEdit,
  faEnvelope as falEnvelope, faEllipsisV, faEllipsisStrokeVertical, faComments,
  faCalendar, faCalendarDay, faCalendarWeek, faCalendarRange,
  faUpRightAndDownLeftFromCenter, faLightbulb, faXmark,
  faPuzzlePiece, faPaperclip,
  faSquareShareNodes, faCalendarLinesPen,
  faTableCells,
  faFilterList, faArrowsRotate,
  faEraser,
  faHand,
  faShieldExclamation,
  faSoap,
  faShieldCheck,
  faCheckCircle,
  faCircleInfo,
  faRightFromBracket,
  faFileExclamation,
  faClock,
  faWrench,
  faLink,
  faClipboardListCheck,
  faClipboardList,
  faEnvelopeOpenText,
  faSun,
  faMoon,
  faCircleHalfStroke,
  faArrowRightToBracket,
  faArrowUpFromBracket,
  faBook,
  faCalendarDays,
  faChartBar,
  faCircleExclamation,
  faCodeBranch,
  faFileCirclePlus,
  faFileInvoiceDollar,
  faMagnifyingGlass,
  faRobot,
  faShield,
  faRedo,
  faFunction,
  faPaste,
  faFolder as falFolder
} from '@fortawesome/pro-light-svg-icons';

import
{
  faArrowRightArrowLeft,
  faCircle,
  faCircleCheck,
  faFolderClosed,
  faHexagonNodesBolt,
  faFolderOpen,
  faRotateRight as fadRotateRight,
  faTableCellsHeader,
  faTableCellsHeaderLock,
  faToggleLargeOff,
  faToggleLargeOn,
  faWandMagicSparkles,
  faKeySkeletonLeftRight,
} from '@fortawesome/pro-duotone-svg-icons';

import
{
  faFolder,
  faSquare as fasSquare,
  faSquareCheck,
  faSquareMinus,
  faXmarkLarge,
  faArrowTurnDownRight as fasArrowTurnDownRight,
  faInfoCircle as fasInfoCircle,
  faStar as fasStar,
  faSpinner as fasSpinner,
  faCircleCheck as fasCircleCheck,
  faTriangleExclamation as fasTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons';

/* import font awesome icon component */
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';


// styles
import './styles/tokens.css';   // Theming-tokens (#1209) — må importeres FØR tailwind.css
import './styles/tailwind.css'; // Tailwind utilities (preflight disabled — opt-in styling)
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { updateEnvironmentStore, getEnvironmentVariables } from './helpers/auth';
import { initProviderRegistry, warmRestoreSession, handleShellRedirectResponse } from './helpers/auth/providerRegistry';
import { markAppInteractive } from './helpers/auth/bootPhase';
import { finalizeBoot } from './helpers/auth/bootFinalize';

// register globally

// EDIT
import EditText from '@/components/editComponents/editText.vue';
import EditNumber from '@/components/editComponents/editNumber.vue';
import EditDate from '@/components/editComponents/editDate.vue';
import EditList from '@/components/editComponents/editList.vue';
import EditComment from '@/components/editComponents/editComment.vue';
import EditBool from '@/components/editComponents/editBool.vue';
import EditAutoComplete from '@/components/editComponents/editAutoComplete.vue';
import EditString from '@/components/editComponents/editString.vue';
import EditPercent from '@/components/editComponents/editPercent.vue';
import EditAttachmentIndicator from '@/components/editComponents/editAttachmentIndicator.vue';
import EditTime from '@/components/editComponents/editTime.vue';
import EditReadOnly from '@/components/editComponents/editReadOnly.vue';


import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import CssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker';
import HtmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker';
import TsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';
// import sqlWorker from 'monaco-editor/esm/vs/language/sql/sql.worker?worker'

// Configure Monaco workers
globalThis.MonacoEnvironment = {
  getWorker (_, label)
  {
    if (label === 'json') {
      return new JsonWorker();
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new CssWorker();
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new HtmlWorker();
    }
    if (label === 'ts' || label === 'typescript' || label === 'javascript') {
      return new TsWorker();
    }
    return new EditorWorker();
  },
};

// Erstatt den eksisterende app-initialiseringen med bootstrap-funksjonen
async function bootstrap ()
{
  try {
    // Bruk kun ny router
    const routerModule = await import('./router');

    // Hent router fra modulen
    const router = routerModule.default || routerModule.router;

    const app = createApp(App);
    app.use(createPinia());

    // Oppdater environment store ETTER Pinia er aktivert
    try {
      const config = await getEnvironmentVariables();
      updateEnvironmentStore(config);
      console.log('Environment store oppdatert');

      // Theming (#1209): plukk palette fra config og initialiser themeStore.
      try {
        const { useThemeStore } = await import('./stores/themeStore');
        const themeStore = useThemeStore();
        themeStore.startSystemListener();
        if (config.palette) {
          themeStore.setPalette(config.palette);
        } else {
          // /api/config returnerte uten palette — påkall applyTokens for å
          // sikre at data-theme-attributtet og default-tokens er konsistente.
          themeStore.applyTokens();
        }
      } catch (error) {
        console.warn('Kunne ikke initialisere theme-store:', error);
      }

      // UserPreferences-hydrering (#1270): registrer save-callbacks på
      // theme/appShell/wizardModeToggle slik at deres setter-funksjoner
      // persisterer til backend via /user-preferences. Hydrate-flow trigges
      // automatisk fra storeUserPreferences.getUserPreferences() ved første
      // vellykket fetch.
      try {
        const { useUserPreferencesHydration } = await import('./composables/useUserPreferencesHydration');
        useUserPreferencesHydration().registerSaveCallbacks();
      } catch (error) {
        console.warn('Kunne ikke registrere user-preferences save-callbacks:', error);
      }
    } catch (error) {
      console.warn('Kunne ikke oppdatere environment store:', error);

      // #1359: /api/config kunne ikke lastes (selv etter retry i
      // getEnvironmentVariables). Aktiver loud amber failsafe-drakt + vis synlig
      // feilmelding — skjermen skal ALDRI se ut som prod når vi ikke vet hvilket
      // miljø vi er i. Uten dette falt FE stille til prod-aktige default-tokens.
      try {
        const { useThemeStore } = await import('./stores/themeStore');
        useThemeStore().setUnavailable();
      } catch (themeError) {
        console.warn('Kunne ikke aktivere failsafe-drakt:', themeError);
      }
      try {
        const { useNotificationsStore } = await import('./store/notificationsStore');
        useNotificationsStore().addError(
          'Kunne ikke laste miljø-konfigurasjon',
          'Viser nøytral failsafe-drakt. Last siden på nytt; vedvarer feilen, kontakt drift.'
        );
      } catch (notifyError) {
        console.warn('Kunne ikke vise config-feil-melding:', notifyError);
      }
    }

    // Auth-initialiseringen (task 2677: shell-only, ingen parallell legacy-init):
    // provider-registryen bygges ETTER Pinia er satt opp, men FØR router-guarden
    // kjører — `getActiveProvider()` skal aldri være null på første guard-kall
    // (ellers leses feil motor når persistert aktiv provider er B2C/External ID).
    // Feiler config-lastingen her, feiler boot hardt → showCriticalError —
    // samme brukersynlige utfall som den tidligere legacy-initen.
    await initProviderRegistry();

    // Warm-restore (#1221) — deterministisk konto-restore før router monteres.
    // Etter dette returnerer provider.currentAccount() autoritativt og
    // router-guarden kan basere hasActiveSession() på et rent read.
    try {
      await warmRestoreSession();
    } catch (error) {
      console.warn('[main] warmRestoreSession feilet — guarden vil rute videre til Login:', error);
    }

    // Håndter redirect-respons fra Microsoft login (hvis bruker kommer tilbake
    // fra redirect-flow). AKTIV provider håndterer sitt eget redirect-svar
    // (WI 2113) — provideren som initierte redirecten er alltid den aktive,
    // siden provider-valget persisteres før loginRedirect. Kortslutter uten
    // auth-indikatorer i URL (WI 1218).
    const intendedRouteAfterRedirect = await handleShellRedirectResponse();

    // Bug 2970: etabler en bruker-scopet SignalR-kobling ved boot når identiteten
    // allerede er kjent (warm-restore av en levende sesjon eller retur fra redirect-
    // login). Interaktiv popup-login post-boot dekkes av syncSessionStores. Uten dette
    // ville e-postutfallet (user_{oid}-push) lande ingensteds for en GA i tilgangs-/
    // modul-området eller en søker uten prosjekt. Fire-and-forget; no-op uten bruker-id.
    try {
      const { useNotificationsStore } = await import('./store/notificationsStore');
      useNotificationsStore().initializeConnection().catch((err) => {
        console.error('[main] Kunne ikke etablere bruker-scopet SignalR-kobling:', err);
      });
    } catch (connError) {
      console.error('[main] Feil ved oppstart av bruker-scopet SignalR-kobling:', connError);
    }

    app.use(router);

    // Dyplenke-navigasjon etter redirect-login skjer FØRST etter app.mount()
    // (se finalizeBoot under). Tidligere kjørte `await router.replace(...)` her
    // — før mount — og frøs boot på «Starter ICS…»-spinneren når Login-rutens
    // lazy-chunk / auth-guard ikke resolverte (blokkert popup). (WI 2118)

    // Legg til alle eksisterende komponenter og biblioteker
    // Font-Awesome:
    library.add(
      faEquals, faNotEqual, faSearchMinus, faGreaterThanEqual, faLessThanEqual, faLessThan, faGreaterThan, faSearch, faClockRotateLeft,
      faTimes, faTrash, faTrashCan, faTrashUndo, faTags, faUsersGear, faFileCsv, faFileExcel, faFileLines, faFileImport, faDownToBracket, faBug, faBugSlash,
      faFile, faFileXls, faFileText, faFilePdf, faFileArchive, faFileCode, fadRotateRight, faFileExport, faFileDownload,
      faFileCircleExclamation, faFileZipper, faOctagonExclamation, faMagnifyingGlassChart, faFileMagnifyingGlass, faPlusCircle,
      faMinusCircle, faPlus, faMinus, falInfoCircle, faChartDiagram, faChartLine, faSpinner, faCheck, faAngleDown, faTable, faTableList, faPencil, faPaperPlane,
      faInfinity, faFloppyDisk, faToggleLargeOn, faToggleLargeOff, faSliders, faCogs, faUser, faListDropdown, faRectangleList, faRectangleApi,
      faChartLineUp, faFolder, faChevronDown, faChevronLeft, faChevronRight, faChevronUp,
      falChevronsLeft, falChevronsRight, faCog, faEye, faQuestionCircle, faHouse,
      faUpDownLeftRight, falArrowTurnDownRight,
      faArrowUp, faArrowDown, faArrowLeftLongToLine, faSquare, faSquareCheck, faRotate, faRotateLeft, faColumns3,
      falColumns, falArrowRightArrowLeft, falWandMagicSparkles, falRocket,
      faDiagramProject, faCode, faPenField, faBookmark, faFolderClosed, faGripLines,
      faMemoCircleCheck, faMemoCircleInfo, faFolderOpen, faLayerPlus, faCodeCompare, faArrowRightArrowLeft, faCopy, faCircleCheck, faArrowLeft, falRotateRight,
      faBuilding, faSquareMinus, faTriangleExclamation, faEyeSlash,
      faArrowDownAZ, faBell, faPlay, faCircle, falCircleCheck, faPowerOff,
      faArrowDownZA, faFilter, faQuestion, faUsers, faFilterSlash, faListCheck, faList, faBox,
      falFolderOpen, faFolderCheck, faCabinetFiling, faFolderMagnifyingGlass, faUpFromBracket, faFileArrowUp, faUpRightFromSquare, faShieldHalved, faGlobe,
      faSquarePollHorizontal, faXmarkLarge, faArrowRight, faKeySkeleton, faRightLeftLarge, faHourglassHalf, faWandMagicSparkles,
      fasSquare,
      faBan, faDatabase, faDownload, faExclamationTriangle, faSave, faStar, faFileEdit, fasArrowTurnDownRight, fasInfoCircle, falEnvelope, faLock, faDiamondExclamation, faEllipsisV,
      faEllipsisStrokeVertical, faComments, faArrowDownWideShort, faArrowUpShortWide, fasStar,
      faCalendar, faCalendarDay, faCalendarWeek, faCalendarRange,
      faUpRightAndDownLeftFromCenter, faLightbulb, faXmark,
      faBallotCheck, faPuzzlePiece, faPaperclip,
      faSquareShareNodes, faCalendarLinesPen,
      faKeySkeletonLeftRight,
      faTableCells,
      faTableCellsHeader,
      faTableCellsHeaderLock,
      faHexagonNodesBolt,
      faFilterList,
      faArrowsRotate,
      faEraser,
      faHand,
      faShieldExclamation,
      faSoap,
      faShieldCheck,
      faCheckCircle,
      faCircleInfo,
      faRightFromBracket,
      faFileExclamation,
      faClock,
      faToolbox,
      faWrench,
      faLink,
      faClipboardListCheck,
      faClipboardList,
      faEnvelopeOpenText,
      faSun,
      faMoon,
      faCircleHalfStroke,
      faArrowRightToBracket,
      faArrowUpFromBracket,
      faBook,
      faCalendarDays,
      faChartBar,
      faCircleExclamation,
      faCodeBranch,
      faFileCirclePlus,
      faFileInvoiceDollar,
      faMagnifyingGlass,
      faRobot,
      faShield,
      faRedo,
      faFunction,
      faPaste,
      falFolder,
      fasSpinner,
      fasCircleCheck,
      fasTriangleExclamation
    );
    app.component('FontAwesomeIcon', FontAwesomeIcon);
    app.component('FontAwesomeLayers', FontAwesomeLayers);

    // EDIT komponenter
    app.component('EditText', EditText);
    app.component('EditNumber', EditNumber);
    app.component('EditDate', EditDate);
    app.component('EditList', EditList);
    app.component('EditComment', EditComment);
    app.component('EditBool', EditBool);
    app.component('EditAutoComplete', EditAutoComplete);
    app.component('EditString', EditString);
    app.component('EditPercent', EditPercent);
    app.component('EditTime', EditTime);
    app.component('editReadOnly', EditReadOnly);
    app.component('editAttachmentIndicator', EditAttachmentIndicator);

    // WI 2118: monter appen og arm den interaktive gaten FØR en eventuell
    // dyplenke-navigasjon. markAppInteractive() tillater interaktiv
    // popup-pålogging (token-fallback) — før det punktet kjører
    // `getShellAccessTokenSilentOrPopup` silent-only. Navigasjonen kjøres
    // post-mount slik at en blokkert popup / treg lazy-rute ikke kan fryse
    // oppstarten på «Starter ICS…»-spinneren.
    await finalizeBoot(
      () => app.mount('#app'),
      markAppInteractive,
      () => intendedRouteAfterRedirect
        ? router.replace(intendedRouteAfterRedirect)
        : Promise.resolve()
    );

    // Post-reload-toast (#1349): hvis routeren reloadet pga. versjons-mismatch,
    // vis en kort bekreftelse til brukeren slik at reload ikke føles tilfeldig.
    try {
      const postReloadMessage = sessionStorage.getItem('post-reload-toast');
      if (postReloadMessage) {
        sessionStorage.removeItem('post-reload-toast');
        const { useNotificationsStore } = await import('./store/notificationsStore');
        useNotificationsStore().addInfo(postReloadMessage);
      }
    } catch (error) {
      console.debug('[main] post-reload-toast feilet:', error);
    }

    // Visibility-event (#1349): når fanen får fokus igjen, sjekk om backend
    // har en nyere build-versjon. Bruker fetch direkte (ikke axios) for å
    // unngå auth-token-runde mot et public endepunkt.
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState !== 'visible') return;
      try {
        const res = await fetch('/api/config', { credentials: 'omit', cache: 'no-store' });
        if (!res.ok) return;
        const cfg = await res.json();
        if (cfg?.buildVersion) {
          const { useGlobalStore } = await import('./store/storeGlobal');
          useGlobalStore().markVersionSeen(cfg.buildVersion);
        }
      } catch {
        /* nettverk borte mens fane våkner — ikke noe å varsle om */
      }
    });
  } catch (error) {
    showCriticalError(error);
  }
}

// Start applikasjonen
try {
  await bootstrap();
} catch (error) {
  console.error(error);
}

// Funksjon for å vise feilmelding
function showCriticalError (error)
{
  console.error('Kritisk feil under initialisering:', error);

  // Erstatt bootstrap-loaderen i #app med modernisert feil-card.
  const appRoot = document.getElementById('app');
  if (appRoot) {
    appRoot.innerHTML = '';
  }

  const shell = document.createElement('div');
  shell.style.cssText = `
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    background: linear-gradient(135deg, #5b6cf3 0%, #7c4dff 100%);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  `;

  shell.innerHTML = `
    <div style="
      max-width: 28rem;
      width: 100%;
      background: rgba(255, 255, 255, 0.97);
      border-radius: 16px;
      padding: 2rem;
      text-align: center;
      box-shadow: 0 8px 32px rgba(25, 118, 210, 0.18), 0 2px 8px rgba(0, 0, 0, 0.06);
    ">
      <div style="
        width: 56px;
        height: 56px;
        margin: 0 auto 1rem;
        border-radius: 50%;
        background: rgba(244, 67, 54, 0.12);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.75rem;
        color: #c62828;
      ">⚠</div>
      <h2 style="margin: 0 0 0.75rem; color: #1a237e; font-size: 1.4rem; font-weight: 600;">
        Kunne ikke starte ICS
      </h2>
      <p style="margin: 0 0 0.75rem; color: #555; line-height: 1.5;">
        Klarte ikke laste konfigurasjon fra serveren. Sjekk nettverksforbindelsen
        og prøv igjen — eller kontakt support hvis problemet vedvarer.
      </p>
      <details style="margin: 0 0 1.5rem; text-align: left;">
        <summary style="
          cursor: pointer;
          color: #888;
          font-size: 0.78rem;
          text-align: center;
          padding: 0.25rem;
          list-style: none;
        ">Tekniske detaljer</summary>
        <p style="margin: 0.5rem 0 0; padding: 0.5rem 0.75rem; background: rgba(0, 0, 0, 0.03);
                  border-radius: 6px; font-family: 'Consolas', 'Monaco', monospace;
                  font-size: 0.78rem; color: #777; word-break: break-word;">
          ${(error.message || 'Ukjent feil').replace(/[<>&]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]))}
        </p>
      </details>
      <button onclick="window.location.reload()" style="
        padding: 0.6rem 1.5rem;
        background: #1976d2;
        color: white;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 0.95rem;
        font-weight: 500;
        transition: background 0.2s;
      " onmouseover="this.style.background='#1565c0'" onmouseout="this.style.background='#1976d2'">
        Last siden på nytt
      </button>
    </div>
  `;

  document.body.appendChild(shell);
}

// Global error handler for chunk loading
globalThis.addEventListener('error', (event) =>
{
  if (event.error && event.error.name === 'ChunkLoadError') {
    console.error('ChunkLoadError detected:', event.error);

    // Show user-friendly message
    const message = 'Kunne ikke laste en del av applikasjonen. Prøv å laste siden på nytt.';
    alert(message);

    // Optionally reload the page
    if (confirm('Vil du laste siden på nytt?')) {
      globalThis.location.reload();
    }
  }
});

// Handle unhandled promise rejections (which might include chunk loading failures)
globalThis.addEventListener('unhandledrejection', (event) =>
{
  if (event.reason && event.reason.name === 'ChunkLoadError') {
    console.error('Unhandled ChunkLoadError:', event.reason);
    event.preventDefault(); // Prevent default error handling

    const message = 'Kunne ikke laste en del av applikasjonen. Prøv å laste siden på nytt.';
    alert(message);

    if (confirm('Vil du laste siden på nytt?')) {
      globalThis.location.reload();
    }
  }
});
